import React, { useEffect, useState } from 'react'
import axios from 'axios'

import { Spin } from 'antd'

// Friendlier names for what the row records.
const LOG_TYPE_LABELS = {
  Add: 'Add Item',
  Remark: 'Add/Update Remark',
}


const StoreRoomQtyLog = ({ itemId, itemDetails, lastUpdate }) => {
  const [logs, setLogs] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchLogs = async () => {
      if (!itemId) return

      setIsLoading(true)
      setError(null)

      try {
        const response = await axios.get(
          `/api/v1/admin/stock-check-store/logs/${itemId}`
        )
        const { checkQtyLog } = response.data
        setLogs(checkQtyLog || [])
      } catch (error) {
        console.error('Failed to fetch logs', error)
        setError('Unable to fetch logs. Please try again later.')
      } finally {
        setIsLoading(false)
      }
    }

    fetchLogs()
  }, [itemId, lastUpdate])

  function formatDate(dateString) {
    if (!dateString) return ''
    const date = new Date(dateString)
    const year = date.getFullYear()
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    const day = date.getDate().toString().padStart(2, '0')
    const hours = date.getHours().toString().padStart(2, '0')
    const minutes = date.getMinutes().toString().padStart(2, '0')
    const seconds = date.getSeconds().toString().padStart(2, '0')
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
  }

  return (
    <>
      <div className='border-bottom pb-3 mb-3'>
        <span className='fw-bold me-3'>{itemDetails?.itemCode}</span>
        {itemDetails?.description
          ? itemDetails.description.split(' ').slice(0, 10).join(' ') +
            (itemDetails.description.split(' ').length > 10 ? '...' : '')
          : ''}
      </div>

      <div className='table-responsive'>
        {isLoading ? (
          <div className='text-center py-4'>
            <Spin size='small' />
          </div>
        ) : error ? (
          <div className='text-center text-danger'>{error}</div>
        ) : logs.length === 0 ? (
          <div className='text-center text-muted py-4'>
            No logs available for this item.
          </div>
        ) : (
          <table className='table align-middle mb-0'>
            <thead className='table-light'>
              <tr>
                <th>Date</th>
                <th>User</th>
                <th className='text-center'>Qty</th>
                <th>Type</th>
              </tr>
            </thead>
            <tbody>
              {logs.map((log, index) => (
                <tr key={index}>
                  <td className='text-nowrap'>
                    {formatDate(log?.checkDateTime)}
                  </td>
                  {/* A log whose user was removed used to throw on .code and
                      blank the whole modal. */}
                  <td>{log.user?.code || '-'}</td>
                  <td className='text-center'>
                    {log.type === 'Remark' ? '-' : log.qty}
                  </td>
                  <td>
                    {LOG_TYPE_LABELS[log.type] || log.type}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </>
  )
}

export default StoreRoomQtyLog
